export default __webpack_public_path__ + "static/media/aliwangwang-o.dc9bda28.svg";